// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for GroupFormPage - Tavern Theme */

.ttbFormContainer {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--space-4);
}

.ttbFormHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  padding: var(--space-4);
  background: var(--color-wood-800);
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
}

.ttbFormHeaderTitle {
  flex: 1;
  text-align: center;
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-parchment-100);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
}

.ttbFormHeaderTitle::before {
  content: '⚔️';
  font-size: 20px;
}

/* Form Sections */
.ttbFormSection {
  background: var(--color-parchment-100);
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  margin-bottom: var(--space-4);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.06) 0%, transparent 50%);
}

.ttbFormSectionHeader {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--color-wood-600);
}

.ttbFormSectionIcon {
  font-size: 24px;
}

.ttbFormSectionTitle {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-fire-600);
}

.ttbField {
  margin-bottom: var(--space-4);
}

.ttbField:last-child {
  margin-bottom: 0;
}

.ttbFieldLabel {
  display: block;
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--space-2);
}

.ttbFieldLabel-required::after {
  content: ' *';
  color: var(--color-danger-500);
}

.ttbFieldError {
  margin-top: var(--space-2);
  font-size: 12px;
  color: var(--color-danger-500);
  font-weight: 600;
}

.ttbFieldHint {
  margin-top: var(--space-2);
  font-size: 12px;
  color: var(--color-text-secondary);
}

.ttbInput {
  width: 100%;
  padding: var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  font-family: var(--font-body);
  font-size: 14px;
  background: white;
  color: var(--color-text-primary);
  outline: none;
  transition: all var(--transition-fast);
}

.ttbInput:focus {
  border-color: var(--color-fire-600);
  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.1);
}

.ttbInput:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--color-parchment-200);
}

.ttbInputError {
  border-color: var(--color-danger-500);
  border-width: 2px;
}

.ttbInputError:focus {
  box-shadow: 0 0 0 3px rgba(168, 52, 42, 0.1);
}

.ttbInputTextArea {
  resize: vertical;
  min-height: 120px;
  line-height: 1.5;
}

/* Emblem Picker Styles */
.emblem-picker {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--space-2);
  margin-top: var(--space-2);
}

.emblem-option {
  position: relative;
}

.emblem-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.emblem-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  font-size: 32px;
  cursor: pointer;
  transition: all var(--transition-fast);
  background: white;
}

.emblem-option input:checked + .emblem-icon {
  border-color: var(--color-fire-600);
  background: rgba(184, 71, 14, 0.05);
  transform: scale(1.1);
  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);
}

.emblem-icon:hover {
  border-color: var(--color-fire-500);
  transform: scale(1.05);
}

.emblem-option-selected .emblem-icon {
  border-color: var(--color-fire-600);
  background: rgba(184, 71, 14, 0.05);
}

.char-counter {
  font-size: 12px;
  font-weight: 600;
  margin-top: var(--space-1);
}

.ttbFormActions {
  position: sticky;
  bottom: 0;
  background: var(--color-wood-800);
  border-top: 3px solid var(--color-wood-700);
  padding: var(--space-4);
  margin: var(--space-5) calc(var(--space-4) * -1) calc(var(--space-4) * -1);
  display: flex;
  gap: var(--space-3);
  justify-content: flex-end;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .ttbFormActions {
    flex-direction: column-reverse;
  }
}

@media (min-width: 768px) {
  .ttbFormActions {
    margin: var(--space-5) 0 0;
    bottom: var(--space-4);
    border: 3px solid var(--color-wood-700);
    border-radius: var(--radius-lg);
  }
}

.ttbButtonSubmit {
  height: 52px;
  min-width: 200px;
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-wood-700);
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  font-weight: 700;
  font-family: var(--font-heading);
  font-size: 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-md);
}

.ttbButtonSubmit:hover:not(:disabled) {
  background: var(--color-fire-500);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.ttbButtonSubmit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.ttbButtonOutlineHeader {
  padding: var(--space-2) var(--space-4);
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  color: var(--color-parchment-100);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.ttbButtonOutlineHeader:hover:not(:disabled) {
  background: var(--color-wood-600);
  transform: translateY(-1px);
}

.ttbButtonOutlineHeader:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ttbInputError {
  border: 2px solid var(--app-danger);
}

.ttbFormActions {
  margin-top: 18px;
}

.ttbButtonSubmit {
  height: 48px;
  width: 100%;
  border-radius: 12px;
  border: none;
  background: var(--app-button);
  color: var(--app-button-text);
  font-weight: 800;
  font-size: 15px;
}

.ttbButtonSubmit:disabled {
  opacity: 0.5;
}

/* Emblem picker mobile styles - must be after base .emblem-icon */
@media (max-width: 768px) {
  .emblem-picker {
    gap: var(--space-1);
  }

  .emblem-icon {
    padding: var(--space-2);
    font-size: 24px;
  }
}

@media (max-width: 400px) {
  .emblem-picker {
    gap: 4px;
  }

  .emblem-icon {
    padding: var(--space-1);
    font-size: 20px;
  }
}

/* Visibility Options Styles */
.visibility-options {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.visibility-option {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  background: white;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.visibility-option:hover {
  border-color: var(--color-fire-500);
  background: rgba(184, 71, 14, 0.02);
}

.visibility-option input[type="radio"] {
  margin-top: 2px;
  cursor: pointer;
  accent-color: var(--color-fire-600);
}

.visibility-option-selected {
  border-color: var(--color-fire-600);
  background: rgba(184, 71, 14, 0.05);
  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);
}

.visibility-option-content {
  flex: 1;
}

.visibility-option-title {
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: var(--space-1);
}

.visibility-option-desc {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/GroupForm/GroupFormPage.css"],"names":[],"mappings":"AAEA,0DAA0D;;AAE1D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B;;mFAEiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iCAAiC;EACjC,2CAA2C;EAC3C,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":["@import '../_base.css';\n\n/* Page-specific styles for GroupFormPage - Tavern Theme */\n\n.ttbFormContainer {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: var(--space-4);\n}\n\n.ttbFormHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-5);\n  padding: var(--space-4);\n  background: var(--color-wood-800);\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n}\n\n.ttbFormHeaderTitle {\n  flex: 1;\n  text-align: center;\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n}\n\n.ttbFormHeaderTitle::before {\n  content: '⚔️';\n  font-size: 20px;\n}\n\n/* Form Sections */\n.ttbFormSection {\n  background: var(--color-parchment-100);\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  margin-bottom: var(--space-4);\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.06) 0%, transparent 50%);\n}\n\n.ttbFormSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n  padding-bottom: var(--space-3);\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.ttbFormSectionIcon {\n  font-size: 24px;\n}\n\n.ttbFormSectionTitle {\n  font-family: var(--font-heading);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n}\n\n.ttbField {\n  margin-bottom: var(--space-4);\n}\n\n.ttbField:last-child {\n  margin-bottom: 0;\n}\n\n.ttbFieldLabel {\n  display: block;\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-2);\n}\n\n.ttbFieldLabel-required::after {\n  content: ' *';\n  color: var(--color-danger-500);\n}\n\n.ttbFieldError {\n  margin-top: var(--space-2);\n  font-size: 12px;\n  color: var(--color-danger-500);\n  font-weight: 600;\n}\n\n.ttbFieldHint {\n  margin-top: var(--space-2);\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.ttbInput {\n  width: 100%;\n  padding: var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  font-family: var(--font-body);\n  font-size: 14px;\n  background: white;\n  color: var(--color-text-primary);\n  outline: none;\n  transition: all var(--transition-fast);\n}\n\n.ttbInput:focus {\n  border-color: var(--color-fire-600);\n  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.1);\n}\n\n.ttbInput:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: var(--color-parchment-200);\n}\n\n.ttbInputError {\n  border-color: var(--color-danger-500);\n  border-width: 2px;\n}\n\n.ttbInputError:focus {\n  box-shadow: 0 0 0 3px rgba(168, 52, 42, 0.1);\n}\n\n.ttbInputTextArea {\n  resize: vertical;\n  min-height: 120px;\n  line-height: 1.5;\n}\n\n/* Emblem Picker Styles */\n.emblem-picker {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: var(--space-2);\n  margin-top: var(--space-2);\n}\n\n.emblem-option {\n  position: relative;\n}\n\n.emblem-option input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.emblem-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  font-size: 32px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: white;\n}\n\n.emblem-option input:checked + .emblem-icon {\n  border-color: var(--color-fire-600);\n  background: rgba(184, 71, 14, 0.05);\n  transform: scale(1.1);\n  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);\n}\n\n.emblem-icon:hover {\n  border-color: var(--color-fire-500);\n  transform: scale(1.05);\n}\n\n.emblem-option-selected .emblem-icon {\n  border-color: var(--color-fire-600);\n  background: rgba(184, 71, 14, 0.05);\n}\n\n.char-counter {\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: var(--space-1);\n}\n\n.ttbFormActions {\n  position: sticky;\n  bottom: 0;\n  background: var(--color-wood-800);\n  border-top: 3px solid var(--color-wood-700);\n  padding: var(--space-4);\n  margin: var(--space-5) calc(var(--space-4) * -1) calc(var(--space-4) * -1);\n  display: flex;\n  gap: var(--space-3);\n  justify-content: flex-end;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 768px) {\n  .ttbFormActions {\n    flex-direction: column-reverse;\n  }\n}\n\n@media (min-width: 768px) {\n  .ttbFormActions {\n    margin: var(--space-5) 0 0;\n    bottom: var(--space-4);\n    border: 3px solid var(--color-wood-700);\n    border-radius: var(--radius-lg);\n  }\n}\n\n.ttbButtonSubmit {\n  height: 52px;\n  min-width: 200px;\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-wood-700);\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  font-weight: 700;\n  font-family: var(--font-heading);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-md);\n}\n\n.ttbButtonSubmit:hover:not(:disabled) {\n  background: var(--color-fire-500);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.ttbButtonSubmit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.ttbButtonOutlineHeader {\n  padding: var(--space-2) var(--space-4);\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  color: var(--color-parchment-100);\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.ttbButtonOutlineHeader:hover:not(:disabled) {\n  background: var(--color-wood-600);\n  transform: translateY(-1px);\n}\n\n.ttbButtonOutlineHeader:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ttbInputError {\n  border: 2px solid var(--app-danger);\n}\n\n.ttbFormActions {\n  margin-top: 18px;\n}\n\n.ttbButtonSubmit {\n  height: 48px;\n  width: 100%;\n  border-radius: 12px;\n  border: none;\n  background: var(--app-button);\n  color: var(--app-button-text);\n  font-weight: 800;\n  font-size: 15px;\n}\n\n.ttbButtonSubmit:disabled {\n  opacity: 0.5;\n}\n\n/* Emblem picker mobile styles - must be after base .emblem-icon */\n@media (max-width: 768px) {\n  .emblem-picker {\n    gap: var(--space-1);\n  }\n\n  .emblem-icon {\n    padding: var(--space-2);\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 400px) {\n  .emblem-picker {\n    gap: 4px;\n  }\n\n  .emblem-icon {\n    padding: var(--space-1);\n    font-size: 20px;\n  }\n}\n\n/* Visibility Options Styles */\n.visibility-options {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.visibility-option {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  background: white;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.visibility-option:hover {\n  border-color: var(--color-fire-500);\n  background: rgba(184, 71, 14, 0.02);\n}\n\n.visibility-option input[type=\"radio\"] {\n  margin-top: 2px;\n  cursor: pointer;\n  accent-color: var(--color-fire-600);\n}\n\n.visibility-option-selected {\n  border-color: var(--color-fire-600);\n  background: rgba(184, 71, 14, 0.05);\n  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);\n}\n\n.visibility-option-content {\n  flex: 1;\n}\n\n.visibility-option-title {\n  font-family: var(--font-heading);\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-1);\n}\n\n.visibility-option-desc {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
